import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
// Hardcoded brutalism theme values (matches globals.css)
const brutalismTheme = {
    name: 'brutalism',
    colors: {
        bg: '#FFFFFF',
        surface: '#FFFFFF',
        border: '#000000',
        text: {
            high: '#000000',
            medium: '#52525B',
            low: '#737373',
        },
        primary: '#E85D04',
    },
};
const ThemeContext = createContext(null);
export function ThemeProvider({ children }) {
    // Only brutalism theme is supported currently
    const theme = brutalismTheme;
    return (_jsx(ThemeContext.Provider, { value: { theme }, children: _jsx("div", { "data-theme": "brutalism", children: children }) }));
}
export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
//# sourceMappingURL=ThemeContext.js.map